import { Chat } from './protocol/types'

// Mirrors the server's authorization rules so the UI never offers an action
// the server would reject: any participant may archive a direct chat, only
// the creator may archive a group, and only groups can be left.
export function canArchive(chat: Chat, userId: string): boolean {
  return !chat.isGroup || chat.createdBy === userId
}

export function canLeave(chat: Chat): boolean {
  return chat.isGroup
}
